export const environment = {
  production: true,
  apiUrl: 'https://api.aiville.fsf.tools',
  googleMaps: {
    apiKey: process.env.FE_GOOGLE_MAPS_API_KEY ?? '',
    center: { lat: 51.165691, lng: 10.451526 },
    zoom: 6,
  },
  mockApi: false,
};
